import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Facebook from 'src/app/components/Facebook';
import {
  accountFormRegulationsSetValidationMessage
} from 'src/app/redux/actions/registration/account/accountFormAgreementsRegulations';
import { sendFacebookRegistrationForm } from 'src/app/redux/actions/registration/account/accountForm';
import {
  accountFormPasswordSetValidationMessage
} from 'src/app/redux/actions/registration/account/accountFormPassword';
import { accountEmailSetValidationMessage } from 'src/app/redux/actions/registration/account/accountFormEmail';
import 'src/app/containers/Registration/Account/AccountFormFacebookContainer.scss';


class AccountFormFacebookContainer extends React.Component {

  submit = (event) => {
    event.preventDefault();
    const { regulationChecked, agreements, regulationsCheckboxRef, dispatch } = this.props;

    dispatch(accountFormPasswordSetValidationMessage(''));
    dispatch(accountEmailSetValidationMessage(''));

    if (!regulationChecked) {
      dispatch(accountFormRegulationsSetValidationMessage(regulationsCheckboxRef.current.validationMessage));
      return;
    }

    dispatch(sendFacebookRegistrationForm(agreements));
  };

  render() {
    const { submit } = this;
    const { sending } = this.props;

    return (
      <button onClick={ submit }
              type="button"
              styleName="facebook-registration"
              disabled={ sending }
              data-test="button-facebook-registration"
      >
        <Facebook />
        <span>Zarejestruj się Facebookiem</span>
      </button>
    );
  }
}

AccountFormFacebookContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired,
  regulationChecked: PropTypes.bool.isRequired,
  regulationsCheckboxRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
  agreements: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string,
    extendedText: PropTypes.string,
    id: PropTypes.number,
    links: PropTypes.array,
    text: PropTypes.string
  })).isRequired
};

const mapStateToProps = (store) => ({
  agreements: store.accountFormAgreementsReducer.agreements,
  regulationChecked: store.accountFormRegulationsReducer.checked,
  sending: store.accountFormReducer.sending
});

export default connect(mapStateToProps)(AccountFormFacebookContainer);
